module.exports = __webpack_public_path__ + "img/full0-min.4c02635a.png";